// extracted by mini-css-extract-plugin
export default {"container":"burger-constructor-total_container__h7bS9","currency":"burger-constructor-total_currency__9ocsV"};